import type { CSSProperties } from 'react'
import type { Color } from '@/gen/sanity/schema'

export interface LinkColors {
  backgroundColor?: string
  textColor?: string
}

export interface SanityLinkColorFields {
  backgroundColor?: Color | null
  textColor?: Color | null
}

export const toLinkColors = (link?: SanityLinkColorFields | null): LinkColors => ({
  backgroundColor: link?.backgroundColor?.hex,
  textColor: link?.textColor?.hex,
})

export const getLinkColorStyle = ({ backgroundColor, textColor }: LinkColors): CSSProperties => ({
  backgroundColor,
  color: textColor,
})

export const getHighlightedLinkStyle = (colors: LinkColors): CSSProperties =>
  colors.backgroundColor
    ? { ...getLinkColorStyle(colors), paddingInline: '0.5rem', borderRadius: '4px' }
    : getLinkColorStyle(colors)
